import axios from 'axios'

const apiClient = axios.create();

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export default {
    mapAgencyNrToOffices(nr){
        return apiClient.post('https://www.cleverads.de/dcx/mapAgencyNrToOffices',
            {
                dataSet: nr
            },
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
    }
}
